import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const labelsRoutes: RouteObject[] = [
  {
    path: ROUTES.LABELS.LIST,
    element: (
      <PrivateRoute>
        <Pages.Labels />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.LABELS.CREATE,
    element: (
      <PrivateRoute>
        <Pages.AddLabels />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.LABELS.EDIT(':id'),
    element: (
      <PrivateRoute>
        <Pages.EditLabels />
      </PrivateRoute>
    ),
  },
]

export default labelsRoutes
